<template>
  <div class="Lightbox whiteBG" id="ProductDetail">
    <div v-if="showOverlay" @click="close" class="LightboxOverlay"></div>
    <div class="LightboxWrap">
      <div class="Content">
        <div class="Titlebar">
          <h3>商品詳細說明</h3>
          <div class="BtnClose">
            <a @click="close" class="Close">Close</a>
          </div>
        </div>
        <div class="ScrollBox">
          <div class="ProductIntroName">
            <router-link :to="'/product?pid=' + pid + '&cid=' + cid">{{ detailInfo.name }}</router-link>
          </div>
          <!-- <div class="ProcuctNum">商品訂購代號 {{detailInfo.pid}}</div> -->
          <div class="ProductSimpleIntor" v-html="productIntroFilters"></div>
          <div class="ProductRow">
            <div class="ProductTitle">- 商品說明 -</div>
            <div class="ProductIntro" v-html="productDescriptionFilters">
            </div>
          </div>
          <!-- <div class="ProductRow">
          <div class="ProductTitle">- 商品規格 -</div>
          <div
            class="ProductIntro"
            v-html="productSpecFilters"></div>
        </div> -->
          <!-- <div class="ProductRow">
            <div class="ProductTitle">- 購物須知 -</div>
            <div class="ProductIntro">
              <iframe :src="productGuideFilters" marginwidth="0" marginheight="0" class="guide_box"></iframe>
            </div>
            <div>
              <font style="color: #ffffff;">{{ detailInfo.pid }}</font>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productdetail",
  data() {
    return {
      showOverlay: false,
      detailInfo: {},
      productIntro: '',
      productDescription: '',
      productSpec: '',
      productGuide: ''
    };
  },
  props: {
    pid: {
      type: Number,
      required: true
    },
    cid: {
      type: Number,
      required: true
    }
  },
  created() {
    this.showOverlay = this.isMobile ? false : true;

    const cacheName = `bestshop_product_detail_${this.pid}`;
    const cache = this.storage.get(cacheName, true);
    if (cache) {
      this.detailInfo = cache;
      this.productIntro = cache.intro;
    } else {
      fetch(`${this.configs.frontCloudApiPath()}product/v3/${this.pid}`)
        .then(res => res.json())
        .then(res => {
          const data = res.resultData;
          this.detailInfo = data;
          this.productIntro = data.intro;
          this.storage.set(cacheName, data, this.configs.webCacheExpireTime, true);
        });
    }

    fetch(`${this.configs.frontCloudApiPath()}product/v3/${this.pid}/description`)
      .then(res => res.json())
      .then(res => {
        const data = res.resultData;
        this.productDescription = data.description;
      });
  },
  mounted() {
    const ifm = this.$el.querySelector('.guide_box');
    ifm.onload = () => {
      const ifmBody = ifm.contentWindow.document.body;
      const ifmBodyNewStr = ifmBody.innerHTML.replace(/<a\b[^>]*>(.*?)<\/a>/ig, '$1');
      ifmBody.innerHTML = ifmBodyNewStr;
    };
  },
  computed: {
    productDescriptionFilters() {
      let content = this.productDescription;
      if (content) {
        content = this.tools.replaceTplImagePath(content);
        return this.tools.replaceWidthAndHeight(content);
      }
      return '';
    },
    // productSpecFilter() {
    //   let content = this.productSpec
    //   content = content.replace(/(width:[\s\d]+px;?)/gi, '')
    //   content = this.tools.replaceTplImagePath(content)
    //   return content
    // },
    productIntroFilters() {
      let content = this.productIntro;
      if (content) {
        content = content.replace(/\\r\\n/g, "");
        return this.tools.replaceWidthAndHeight(content);
      }
      return '';
    },
    // productGuideFilters() {
    //   return `https://${this.configs.subDomain()}.shopping.friday.tw/mobileweb/app/shopping/guide/shopping_guide`;
    // },
    // productSpecFilters() {
    //   let content = this.productSpec
    //   content = content.replace(/(style=".*?")/i, '')
    //   content = this.tools.replaceTplImagePath(content)
    //   return this.tools.replaceWidthAndHeight(content)
    // }
  },
  methods: {
    close() {
      this.$emit("closeDetail");
    }
  }
};
</script>

<style lang="scss">
.block-content {
  img {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.description_box {
  width: 100%;
  border: 0px;
}

.guide_box {
  width: 100%;
  height: 500px;
  margin-top: -5px;
  margin-left: -15px;
  border: 0px;
}

.ProductIntroName {
  font-weight: 700;
  margin-bottom: 0.5%;
  font-size: 1rem;
}

.ProcuctNum {
  margin-bottom: 0.5%;
}

.ProductSimpleIntor {
  margin-bottom: 5%;
}

.ProductIntro {
  padding: 1%;
  font-size: 13px;
}

@media (max-width: 768px) {
  .ScrollBox {
    max-height: 92vh;
  }
}
</style>
